// extracted by mini-css-extract-plugin
module.exports = {"input":"SearchBar_input__35An9","btn":"SearchBar_btn__q6G3X"};